import { useState } from 'react';

const useSelectionState = () => {
    const [cards, setCards] = useState([]);
    const [selectedCharacter, setSelectedCharacter] = useState(null);
    const [selectedCard, setSelectedCard] = useState(null);
    const [stats, setStats] = useState([]);
    const [editableStats, setEditableStats] = useState({});
    const [aptitudes, setAptitudes] = useState({});
    const [selectedStars, setSelectedStars] = useState(3);
    const [potentialLevel, setPotentialLevel] = useState(0);

    return {
        cards, setCards,
        selectedCharacter, setSelectedCharacter,
        selectedCard, setSelectedCard,
        stats, setStats,
        editableStats, setEditableStats,
        aptitudes, setAptitudes,
        selectedStars, setSelectedStars,
        potentialLevel, setPotentialLevel
    };
};

export default useSelectionState;
// Revisado: 2025-12-16
